/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import { Breadcrumb, Col, Divider, Empty, Row, Statistic, Tabs } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from 'react'
import { EyeFilled, HeartFilled, HeartOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { fileTypes } from "../../../common/types/types";
import { Swiper, SwiperSlide } from "swiper/react";
import Mess from '../../../../assets/images/mess.png';
import Facebook from '../../../../assets/images/facebook.png';
import Zalo from '../../../../assets/images/zalo.png';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";


// import required modules
import ProductDetail from "./components/ProductDetail";
import SellerDetail from "./components/SellerDetail";
import RelatedDocuments from "./components/RelatedDocuments";
// import { StartStatus } from "../../types";
import { useLazyGetClientAuctionItemQuery, useLazyGetClientAuctionListQuery } from "../../redux/AuctionApi";
import StatuteDetail from "./components/StatuteDetail";
import { useLazyGetFileByObjectIdAndTypeQuery } from "../../../../redux/api/FileApi";
import { UploadFileResponse } from "../../../../redux/api/apiTypes";
import ItemCardOther from "../../../common/components/ItemCardOther";
import AuctionSwiper from "../../../common/components/AuctionSwiper";
import { useCareProductMutation, useUncareProductMutation } from "../../../../redux/api/ProductApi";
import { useAppDispatch, useAppSelector } from "../../../../redux/Hooks";
import { toggleLoginModal } from "../../../login/redux/LoginSlice";
const { TabPane } = Tabs;

const AuctionItem = () => {
    const [tabs, setTabs] = useState(1)
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const [imageList, setImageList] = useState<UploadFileResponse[]>([]);

    const params = useParams();
    const location = useLocation();

    const userState = useAppSelector(state => state.login);
    const dispatch = useAppDispatch();

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();

    const [trigger, response] = useLazyGetClientAuctionItemQuery();
    const [fileTrigger, fileResponse] = useLazyGetFileByObjectIdAndTypeQuery();
    const [listTrigger, listResponse] = useLazyGetClientAuctionListQuery();

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (params.id && params.statuteId && divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [params.id, params.statuteId])

    useEffect(() => {
        if (params.statuteId && parseInt(params.statuteId)) {
            listTrigger({
                page: 0,
                size: 6,
                status: 124,
                type: 1,
                statuteId: parseInt(params.statuteId)
            })
        }
    }, [listTrigger, params.statuteId])

    useEffect(() => {
        if (params.id && params.statuteId) {
            trigger({ productId: parseInt(params.id), statuteId: parseInt(params.statuteId) });
            fileTrigger({
                objectId: parseInt(params.id),
                objectType: fileTypes.PRODUCT,
            })
        }
    }, [params.id, trigger, fileTrigger, params.statuteId])

    useEffect(() => {
        if (fileResponse.data?.length) {
            setImageList(fileResponse.data.filter(item => item.storageType === "image" || item.storageType === "avatar"))
        }
    }, [fileResponse])

    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const generateMoreItems = () => {

        if (listResponse.data?.content?.length) {
            let auctionList = listResponse.data.content.filter(listItem => listItem.productId !== response.data?.productId).slice(0, 5);
            let returnData: React.ReactNode[] = [];

            if (listResponse.data.totalElements > 6) {
                returnData.push(
                    <Col span={24} key="more">
                        <Row justify="center">
                            <Col
                                style={{ textAlign: 'right' }}
                                md={8 * auctionList.length >= 24 ? 24 : 8 * auctionList.length}
                                lg={6 * auctionList.length >= 24 ? 24 : 6 * auctionList.length}
                                xl={4 * auctionList.length >= 24 ? 24 : 4 * auctionList.length}
                            >
                                <Link to={"/auction-list-other"}>
                                    Xem tất cả
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                )
            }

            auctionList.forEach((listItem, index) => {
                returnData.push(
                    <Col md={8} lg={6} xl={4} key={listItem.productId} className="item-card-price-small">
                        <ItemCardOther
                            item={listItem}
                            reloadPage={() => {
                                listTrigger({
                                    page: 0,
                                    size: 5,
                                    status: 124,
                                    type: 1
                                })
                            }} />
                    </Col>
                )
            })
            return returnData;
        }
        return (<Col span={24}>Hiện không có dữ liệu tài sản khác</Col>);
    }

    const onFavoriteClick = () => {
        if (response.data?.productId && userState.user.userId) {
            if (response.data?.isCare) {
                // uncare
                uncareProduct({ productId: response.data?.productId, statuteId: response.data?.statute.statuteId }).unwrap().then(() => {
                    trigger({ productId: response.data?.productId || 0, statuteId: response.data?.statute.statuteId || 0 });
                })
            } else {
                // care
                careProduct({ productId: response.data?.productId, statuteId: response.data?.statute.statuteId }).unwrap().then(() => {
                    trigger({ productId: response.data?.productId || 0, statuteId: response.data?.statute.statuteId || 0 });
                })
            }
        } else if (!userState.user.userId) {
            // Nếu chưa đăng nhập => hiển thị modal đăng nhập
            dispatch(toggleLoginModal());
        }
    }

    return (
        <div
            ref={divRef}
            style={{
                padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                // alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%'
            }}
        >
            <Breadcrumb separator="  " className="custom-breadcrumb">
                <Breadcrumb.Item>
                    <Link to="/">
                        Trang chủ
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/auction-list-other">
                        Danh sách tài sản
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Chi tiết tài sản
                </Breadcrumb.Item>
            </Breadcrumb>
            <Row gutter={70} style={{ marginTop: '30px', width: '100%' }} className="responsive-padding-1440">
                <Col xs={12} style={{ display: 'flex', flexDirection: 'column', maxHeight: 500 }}>
                    <AuctionSwiper imageList={imageList} key={`${params.id || 0}`} />
                </Col>
                <Col xs={12}>
                    <div style={{ padding: '2px 15px', backgroundColor: '#DCDCDC', display: 'inline-block' }}>
                        <span>Mã tài sản</span>
                        <span className="font-bold"> {response.data?.productCode || ""}</span>
                    </div>
                    <h2 style={{ fontWeight: 'bold' }}>{response.data?.productName || ""}</h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: '1.2' }}>
                        <div>
                            <div>Giá khởi điểm:</div>
                            <div style={{ fontSize: '26px', display: 'flex', alignItems: 'center' }}>
                                <Statistic
                                    value={response.data?.startPrice || 0}
                                    groupSeparator="."
                                    decimalSeparator=","
                                    precision={0}
                                    style={{ marginRight: 5 }}
                                    valueStyle={{ fontSize: 26, fontFamily: 'Quicksand' }} /> VNĐ
                            </div>
                        </div>
                    </div>

                    <div className="list-details" style={{ marginTop: '30px' }}>
                        {/* <div style={{ display: 'flex' }}>
                            <span>Bước giá:</span>
                            <span style={{ fontWeight: 'bold', display: 'flex', marginLeft: 5 }}>
                                <Statistic
                                    value={response.data?.biddingCostPerBid || 0}
                                    groupSeparator="."
                                    decimalSeparator=","
                                    precision={0}
                                    style={{ marginRight: 5 }}
                                    valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} /> VNĐ
                            </span>
                        </div> */}
                        <div style={{ display: 'flex' }}>
                            <span>Tiền đặt trước:</span>
                            <span style={{ fontWeight: 'bold', display: 'flex', marginLeft: 5 }}>
                                <Statistic
                                    value={response.data?.preCost || 0}
                                    groupSeparator="."
                                    decimalSeparator=","
                                    precision={0}
                                    style={{ marginRight: 5 }}
                                    valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} /> VNĐ
                            </span>
                        </div>
                        <div>
                            <span>Địa điểm có tài sản:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                                {response.data?.addressHasProperty || ""}
                            </span>
                        </div>
                        {/* <div>
                            <span>Thời gian đăng ký tham gia:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                                {response.data?.statute.startRegistrationDate && response.data?.statute.endRegistrationDate ?
                                    `Từ ${format(response.data?.statute.startRegistrationDate, "HH:mm:ss dd/MM/yyyy")} đến ${format(response.data?.statute.endRegistrationDate, "HH:mm:ss dd/MM/yyyy")}` :
                                    ""
                                }
                            </span>
                        </div> */}
                        <div>
                            <span>Địa điểm đăng ký đấu giá:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                                {response.data?.statute.note1 || ""}
                            </span>
                        </div>
                        {/* <div>
                            <span>Thời gian bắt đầu phiên đấu giá:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                                {response.data?.statute.startDate ?
                                    `${format(response.data?.statute.startDate, "HH:mm:ss dd/MM/yyyy")}` :
                                    ""
                                }
                            </span>
                        </div> */}
                        <div>
                            <span>Địa điểm đấu giá:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                                {response.data?.statute.address || ""}
                            </span>
                        </div>
                        <div>
                            <span>Hình thức đấu giá:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{response.data?.statute.auctionType?.name || ""}
                            </span>
                        </div>
                        <div>
                            <span>Phương thức trả giá:</span>
                            <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{response.data?.statute.auctionMethod?.name || ""}</span>
                        </div>
                        {/* {response.data?.statute.auctionType?.id === 2 ?
                            <div>
                                <span>Thời gian trả giá:</span>
                                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{response.data?.statute.timePerPriceDown || 0} phút</span>
                            </div>
                            :
                            <>
                                <div>
                                    <span>Số vòng đấu giá:</span>
                                    <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{response.data?.statute.totalRound || 0} vòng</span>
                                </div>
                                <div>
                                    <span>Thời gian mỗi vòng đấu giá:</span>
                                    <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{response.data?.statute.incrementInTimePerBid || 0} phút</span>
                                </div>
                            </>

                        } */}
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        <Row style={{ width: '100%' }} justify="space-between">
                            <Col>
                                <Divider style={{ marginBottom: '15px' }} />
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div className="vh-center" style={{ marginRight: 10 }}>
                                        <EyeFilled style={{ fontSize: 25 }} />
                                        <span>&nbsp;{response.data?.views || 0}</span>
                                    </div>
                                    <div className="vh-center" style={{ marginRight: 10 }}>
                                        <div
                                            style={{ alignSelf: 'center', cursor: 'pointer' }}
                                            onMouseEnter={onFavoriteMouseOver}
                                            onMouseLeave={onFavoriteMouseOut}
                                            onClick={onFavoriteClick}>
                                            {isFavoriteHovering || response.data?.isCare ?
                                                <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                                                <HeartOutlined style={{ color: 'black', fontSize: 25 }} />
                                            }

                                        </div>
                                        <span>&nbsp;{response.data?.viewcares || 0}</span>
                                    </div>
                                    <div className="vh-center" style={{ marginRight: 10 }}>
                                        <span>Chia sẻ:&nbsp;</span>
                                        <a target="_blank" rel="noreferrer" href={`https://m.me`}>
                                            <img width={25} src={Mess} alt="messenger" />
                                        </a>
                                        <a target="_blank" rel="noreferrer" href={
                                            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://dgtt.ospgroup.vn/' + location.pathname)}`
                                        }>
                                            <img width={25} src={Facebook} alt="facebook" />
                                        </a>
                                        <a target="_blank" rel="noreferrer" href={`https://chat.zalo.me`}>
                                            <img width={25} src={Zalo} alt="zalo" />
                                        </a>
                                    </div>
                                </div>
                                <Divider style={{ marginTop: '15px' }} />
                            </Col>
                            {/* <Col>
                                <div className="vh-center">
                                    <Button className="button-light-yellow" style={{ height: 50, maxWidth: 240, fontSize: 16 }}>Đăng ký bán đấu giá</Button>
                                </div>
                            </Col> */}
                        </Row>
                    </div>

                </Col>
            </Row>
            <Row justify="center" style={{ width: '100%' }}>
                <Col xs={20}>
                    <div style={{ marginTop: '80px', borderRadius: '15px', background: 'white', padding: '70px 50px 140px 50px', position: 'relative' }}>
                        <div className="tab">
                            <Tabs type="card" className="custom-tab" onChange={(tab) => { setTabs(Number(tab)) }}>
                                <TabPane tab="THÔNG TIN TÀI SẢN" key="1">
                                </TabPane>
                                <TabPane tab="THÔNG TIN TỔ CHỨC ĐẤU GIÁ / NGƯỜI CÓ TÀI SẢN" key="2">
                                </TabPane>
                                <TabPane tab="QUY CHẾ ĐẤU GIÁ" key="3">
                                </TabPane>
                                <TabPane tab="TÀI LIỆU LIÊN QUAN" key="4">
                                </TabPane>
                            </Tabs>
                        </div>
                        {/* <div className="tab">
                            <div className="tab-item active" style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}>
                                THÔNG TIN TÀI SẢN
                            </div>
                            <div className="tab-item">
                                THÔNG TIN TỔ CHỨC ĐẤU GIÁ / NGƯỜI CÓ TÀI SẢN
                            </div>
                            <div className="tab-item">
                                QUY CHẾ ĐẤU GIÁ
                            </div>
                            <div className="tab-item">
                                TÀI LIỆU LIÊN QUAN
                            </div>
                        </div> */}
                        {tabs === 1 && <ProductDetail item={response.data} />}
                        {tabs === 2 && <SellerDetail item={response.data} />}
                        {tabs === 3 && <StatuteDetail item={response.data} />}
                        {tabs === 4 && <RelatedDocuments item={response.data} />}

                    </div>

                </Col>
            </Row>
            {listResponse.data?.totalElements && listResponse.data?.totalElements > 1 ?
                <>
                    <div style={{ marginTop: '40px', textAlign: 'center', marginBottom: '10px' }}>
                        <h1 style={{ color: 'black', letterSpacing: '0.1em' }}>TÀI SẢN KHÁC</h1>
                    </div>
                    <Row gutter={[5, 20]} justify="center" style={{ width: '100%' }}>
                        {generateMoreItems()}
                    </Row>
                </> : <></>}
        </div>
    )
}

export default AuctionItem